import { I18nComponente } from "@/types/gerais"

export const OCapacidadeValori18n: I18nComponente = {
  "pt-BR": {
    chaveDePeriodoDeConsumoIndefinida: "chave de periodo de consumo indefinida"
  },
  "es-CO": {
    chaveDePeriodoDeConsumoIndefinida: "clave de periodo de consumo indefinido"
  }
}
